import { Lines, FadeUp } from "./Reveal";
import { SectionLabel } from "./Btn";

export const PageIntro = ({ n = 0, label, title, text, testid }) => (
  <section className="px-6 sm:px-10 lg:px-14 pt-40 sm:pt-48 pb-16 sm:pb-24" data-testid={testid}>
    <SectionLabel n={n}>{label}</SectionLabel>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-10 items-end">
      <Lines as="h1" onMount delay={0.1} lines={[title]} className="lg:col-span-8 f-serif font-light tracking-[-0.025em] leading-[0.98] text-5xl sm:text-6xl lg:text-8xl" />
      {text && (
        <FadeUp className="lg:col-span-4" delay={0.3}>
          <p className="text-lg leading-[1.75] text-[#3A3A3A]">{text}</p>
        </FadeUp>
      )}
    </div>
  </section>
);
